import { getDataMapper, mapField } from "@/shared";

export const mapBreakingToServer = getDataMapper(
    {
        id: mapField("id", Number),
        title: mapField("title"),
        price: mapField("price", Number),
    },
    {
        shouldAvoidUndefined: true,
    }
);
